import React, { Component } from 'react'
import PropTypes from 'prop-types'

class YouTubeSearchForm extends Component {
    render() {
        const { plugin } = this.props
        return (
        <div className="desc_plugin14">
            <p className="txt_plugin">
                동영상 공유 서비스인 YouTube의 동영상을 검색하여 게시글에 첨부할 수 있습니다.<a href="https://www.youtube.com" target="_blank" className="link_other">YouTube 바로가기</a>
            </p>
            <p className="txt_other">
                글쓰기의 플러그인에서 YouTube 플러그인을 확인하실 수 있습니다.
            </p>
            {this.props.saveButton()}
        </div>
        )
    }
}

YouTubeSearchForm.propTypes = {
    plugin: PropTypes.object.isRequired
}

export default YouTubeSearchForm
